import { Controller } from "@hotwired/stimulus"

// Six single-digit boxes that behave like one field. Writes into `hidden`.
export default class extends Controller {
  static targets = ["box", "hidden"]

  connect() {
    this.boxTargets[0]?.focus()
  }

  input(event) {
    const box = event.target
    box.value = box.value.replace(/\D/g, "").slice(-1)
    this.sync()
    if (box.value) this.focusNext(box)
  }

  keydown(event) {
    const box = event.target
    if (event.key === "Backspace" && !box.value) this.focusPrev(box)
  }

  paste(event) {
    const digits = (event.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, this.boxTargets.length)
    if (!digits) return
    event.preventDefault()
    digits.split("").forEach((d, i) => (this.boxTargets[i].value = d))
    this.sync()
    this.boxTargets[Math.min(digits.length, this.boxTargets.length - 1)].focus()
  }

  sync() {
    this.hiddenTarget.value = this.boxTargets.map((b) => b.value).join("")
  }

  focusNext(box) {
    const i = this.boxTargets.indexOf(box)
    this.boxTargets[i + 1]?.focus()
  }

  focusPrev(box) {
    const i = this.boxTargets.indexOf(box)
    this.boxTargets[i - 1]?.focus()
  }
}
